import React, { useState, useEffect } from 'react';
import '../styles/Notifications.css';
import { getAllNotifications, sendNotification, updateNotification, deleteNotification } from '../services/api';

function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [newNotification, setNewNotification] = useState({ message: '', clientId: '' });
  const [editNotification, setEditNotification] = useState(null);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const data = await getAllNotifications();
        setNotifications(data);
      } catch (err) {
        console.error('Failed to fetch notifications:', err);
      }
    };
    fetchNotifications();
  }, []);

  const handleSend = async (e) => {
    e.preventDefault();
    try {
      const notificationData = { ...newNotification, date: new Date().toISOString() };
      const response = await sendNotification(notificationData);
      setNotifications([...notifications, response]);
      setNewNotification({ message: '', clientId: '' });
    } catch (err) {
      alert('Failed to send notification.');
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await updateNotification(editNotification.id, editNotification);
      setNotifications(notifications.map(n => n.id === editNotification.id ? editNotification : n));
      setEditNotification(null);
    } catch (err) {
      alert('Failed to update notification.');
    }
  };

  const handleDelete = async (notificationId) => {
    if (window.confirm('Are you sure you want to delete this notification?')) {
      try {
        await deleteNotification(notificationId);
        setNotifications(notifications.filter(n => n.id !== notificationId));
      } catch (err) {
        alert('Failed to delete notification.');
      }
    }
  };

  return (
    <div className="ap-notifications">
      <h2 className="ap-notifications-title">Notifications</h2>
      <form className="ap-notification-form" onSubmit={handleSend}>
        <input
          className="ap-notification-input"
          type="text"
          placeholder="Message"
          value={newNotification.message}
          onChange={(e) => setNewNotification({ ...newNotification, message: e.target.value })}
          required
        />
        <input
          className="ap-notification-input"
          type="text"
          placeholder="Client ID (optional)"
          value={newNotification.clientId}
          onChange={(e) => setNewNotification({ ...newNotification, clientId: e.target.value })}
        />
        <button className="ap-send-btn" type="submit">Send</button>
      </form>
      <ul className="ap-notifications-list">
        {notifications.map((notification) => (
          <li key={notification.id} className="ap-notification-item">
            <span className="ap-notification-message">{notification.message} {notification.clientId ? `(to ${notification.clientId})` : '(All)'}</span>
            <span className="ap-notification-date">{notification.date}</span>
            <button className="ap-edit-btn" onClick={() => setEditNotification(notification)}>Edit</button>
            <button className="ap-delete-btn" onClick={() => handleDelete(notification.id)}>Delete</button>
          </li>
        ))}
      </ul>
      {editNotification && (
        <form className="ap-edit-notification-form" onSubmit={handleUpdate}>
          <h3 className="ap-edit-title">Edit Notification</h3>
          <input
            className="ap-notification-input"
            type="text"
            value={editNotification.message}
            onChange={(e) => setEditNotification({ ...editNotification, message: e.target.value })}
            required
          />
          <input
            className="ap-notification-input"
            type="text"
            value={editNotification.clientId}
            onChange={(e) => setEditNotification({ ...editNotification, clientId: e.target.value })}
          />
          <button className="ap-send-btn" type="submit">Save</button>
          <button className="ap-cancel-btn" type="button" onClick={() => setEditNotification(null)}>Cancel</button>
        </form>
      )}
    </div>
  );
}

export default Notifications;